<template>
  <div class="main">
    <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
      <landingBanner
        landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xuejishu/banner.jpg"
      ></landingBanner>
    </a>

    <div class="content">
      <div class="content-1">
        <div class="title" style="color: #f87104">专业老师在线答疑</div>
        <div class="buttons">
          <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
            <Button type="warning" shape="circle" class="button"
              >入学条件</Button
            >
            <Button type="warning" shape="circle" class="button"
              >初高中生学什么好</Button
            >
            <Button type="warning" shape="circle" class="button"
              >学校环境如何</Button
            >
            <Button type="warning" shape="circle" class="button"
              >需要基础吗</Button
            >
            <Button type="warning" shape="circle" class="button"
              >有哪些特色专业</Button
            >
            <Button type="warning" shape="circle" class="button"
              >就业前景怎样</Button
            >
          </a>
        </div>
        <div class="title" style="font-size: 18px">
          优势一：专注教育培训33年-专业职业教育学校
        </div>
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xuejishu/p1.jpg"
        ></van-image>
        <div class="c1">
          <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
          <Button type="warning" shape="circle" long class="button" 
            >咨询老师入学条件</Button
          >
          </a>
        </div>
        <div class="title" style="font-size: 18px">
          优势二：热门专业发展前景
        </div>
        <div class="c1">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xuejishu/p2.jpg"
          ></van-image>
          <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
          <Button type="warning" shape="circle" long class="button" 
            >成绩不好能学会吗？点击咨询</Button
          ></a>
        </div>
        <div class="title" style="font-size: 18px">
          优势三：技能+就业 择业无忧
        </div>
        <div class="c1">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xuejishu/p3.jpg"
          ></van-image>
          <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
          <Button type="warning" shape="circle" long class="button" 
            >学籍咨询 </Button
          ></a>
        </div>
        <div class="title" style="font-size: 18px">
          优势四：欧式教学环境，梦想开始的地方
        </div>
        <div class="c1">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xuejishu/p4.jpg"
          ></van-image>
        </div>
        <div class="buttons">
          <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
            <Button
              type="warning"
              shape="circle"
              class="button"
              style="background: #b85c38; border-color: #b85c38; width: 45%"
              >选择专业</Button
            >
            <Button
              type="warning"
              shape="circle"
              class="button"
              style="background: #f87104; border-color: #f87104; width: 45%"
              >了解学费</Button
            >
          </a>
        </div>
        <div class="h25px" style="width: 100%; height: 25px"></div>
        
        <footerForm
          color="#fff"
          bag="#f87104"
          words="点击获取学费报价"
        ></footerForm>
      </div>
    </div>
    <div class="h25px" style="width: 100%; height: 25px"></div>
    <foot></foot>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  components: {
    landingBanner: () => import("../../../components/common/landing-banner"),
    foot: () => import("@/components/foot/foot"),
    indexTitle: () => import("@/components/common/indexTitle"),
    footerForm: () => import("@/components/form/footerForm"),
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
body {
  background-color: #fff;
}
.title {
  width: 100%;
  padding: 10px;
  font-size: 25px;
  font-weight: 600;

  text-align: center;
}
.buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.button {
  font-size: 15px;
  font-weight: 600;
  margin-right: 5px;
  margin-bottom: 5px;
}
.ivu-btn-warning {
  color: #fff;
  background-color: #f87104;
  border-color: #f87104;
}
.c1 {
  width: 100%;
  padding: 10px;
}
</style>